import { supabase } from "./supabaseClient";
import { store } from "@/lib/states/store";
type InvokeOptions = Parameters<typeof supabase.functions.invoke>[1];
type InvokeResponse<T> = Awaited<ReturnType<typeof supabase.functions.invoke<T>>>;

export async function invokeEdgeFunction<T = any>(
  name: string,
  options?: InvokeOptions,
): Promise<InvokeResponse<T>> {
  const orgId = store.getState().session.org?.id ?? null;
  const headers: Record<string, string> = {
    ...(options?.headers ?? {}),
    apikey: import.meta.env.VITE_SUPABASE_PB_KEY,
  };

  if (orgId) {
    headers["x-org-id"] = orgId;
  }

  return supabase.functions.invoke<T>(name, {
    ...options,
    headers,
  });
}
